import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AsteriskIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "11",
    y: "5",
    width: "2",
    height: "14",
    rx: "1"
  }), /*#__PURE__*/_jsx("rect", {
    x: "11",
    y: "5",
    width: "2",
    height: "14",
    rx: "1",
    transform: "translate(-4.39 16.39) rotate(-60)"
  }), /*#__PURE__*/_jsx("rect", {
    x: "11",
    y: "5",
    width: "2",
    height: "14",
    rx: "1",
    transform: "translate(16.39 -4.39) rotate(60)"
  })]
}), 'AsteriskIcon');